import { Photo } from '@gql/schema';
import { Device, GalleryElement, applySizeToImageUrl } from '@secretescapes/falcon';

interface ImageDimensions {
  width: number;
  height: number;
}

type DeviceImageDimensions = Record<Device, ImageDimensions>;

export const IMAGE_DIMENSIONS: DeviceImageDimensions = {
  [Device.mobile]: { width: 600, height: 400 },
  [Device.tablet]: { width: 640, height: 427 },
  [Device.desktop]: { width: 640, height: 427 },
};

export const ROOM_IMAGE_DIMENSIONS: DeviceImageDimensions = {
  [Device.mobile]: { width: 566, height: 283 },
  [Device.tablet]: { width: 482, height: 241 },
  [Device.desktop]: { width: 482, height: 241 },
};

export const EXPIRED_IMAGE_URL =
  'https://images.secretescapes.io/c/sales/generic/image_expired.jpg';

export const constructImageUrl = (image: Photo, dimensions: ImageDimensions) => {
  return image.urlWithSize
    ? applySizeToImageUrl(image.urlWithSize, dimensions.width, dimensions.height)
    : (image.url ?? '');
};

export const mapToGalleryElement = (
  photo: Photo,
  index: number,
  dimensions: ImageDimensions = IMAGE_DIMENSIONS[Device.desktop]
): GalleryElement => ({
  id: `${photo.caption ?? 'image'}/${index + 1}`,
  imgUrl: constructImageUrl(photo, dimensions),
  imgUrlWithSize: photo.urlWithSize ?? undefined,
  title: photo.caption ?? '',
  height: photo.maxHeight ?? undefined,
  width: photo.maxWidth ?? undefined,
});

export const mapPhoto = (
  photo: Photo,
  dimensions: ImageDimensions = ROOM_IMAGE_DIMENSIONS[Device.desktop]
): Photo => ({
  url: constructImageUrl(photo, dimensions),
  caption: photo.caption ?? '',
});
